import { SingleDropzonePlaceholderIcon } from '@ui/kit/icons';
import { usePageContext } from '../../../../../context.js';
import { dropzone, placeholder, dropzoneChildren } from './atom.target.style.js';
import { jsx } from 'react/jsx-runtime';

function DropzoneTarget(props) {
  const pageContext = usePageContext();
  const hasChildren = Array.isArray(props.children) ? props.children.length > 0 : !!props.children;
  if (!hasChildren && props.state === "static") {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: dropzone,
    "data-over": props.isDraggingOverDropzone,
    "data-with-children": hasChildren,
    "data-interactive": props.state === "interactive",
    "data-theme": props.theme,
    "data-page-context": pageContext,
    children: props.state === "interactive" && !hasChildren ? /*#__PURE__*/jsx("div", {
      className: placeholder,
      children: /*#__PURE__*/jsx(SingleDropzonePlaceholderIcon, {})
    }) : /*#__PURE__*/jsx("div", {
      className: dropzoneChildren,
      children: props.children
    })
  });
}

export { DropzoneTarget };
//# sourceMappingURL=atom.target.js.map
